export const actions = {
    SET_IS_LTI: 'SET_IS_LTI',
};

export const setIsLTI = payload => ({
    type: actions.SET_IS_LTI,
    payload,
});
